import { render, staticRenderFns } from "./propList.vue?vue&type=template&id=3ed8fff2&scoped=true&"
import script from "./propList.vue?vue&type=script&lang=js&"
export * from "./propList.vue?vue&type=script&lang=js&"
import style0 from "./propList.vue?vue&type=style&index=0&id=3ed8fff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed8fff2",
  null
  
)

export default component.exports